import { memo } from 'react'

interface LabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
  children: React.ReactNode
}

export const Label = memo(({ children, ...rest }: LabelProps) => {
  // biome-ignore lint/a11y/noLabelWithoutControl: htmlFor is passed via rest props
  return <label {...rest}>{children}</label>
})

Label.displayName = 'Label'
